import config from '@/config'

export const currencies = Object.values(config.currencies).filter(
  (item) => item.enabled
)

export const languages = Object.values(config.languages).filter(
  (item) => item.enabled
)

export const corporations = Object.values(config.corporations)
  .filter((item) => item.enabled)
  .sort((a, b) => a.ordering - b.ordering)
